import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../../apiCalls/rtkBaseQuery';

export const contactApi = createApi({
    baseQuery,
    reducerPath: 'contactApi',
    tagTypes: ['contact'],
    endpoints: (builder) => ({
        getContactList: builder.query({
            query: ({ page = 1, items = 10, search = '' }) => ({
                url: `/admin/site/contact-list?page=${page}&items=${items}`,
                method: 'POST',
                body: {
                    search,
                    sort: {
                        column: 'createdAt',
                        order: 'desc',
                    },
                },
            }),
            keepUnusedDataFor: 0,
            providesTags: ['contact'],
        }),
        deleteContact: builder.mutation({
            query: (id) => ({
                url: `/admin/site/delete-contact/${id}`,
                method: 'POST',
            }),
            invalidatesTags: ['contact'],
        }),
    }),
});

export const {
    useDeleteContactMutation,
    useGetContactListQuery,
} = contactApi;
